Librarian.Modules.Favorites = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-favorites-",
        orderBy: "DateTime",
        order: "desc",
        count: 20,
        showDate: false,
        dateFormat: "%m/%d/%Y",
        action: "preview" // Or "open"
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function () {
        if (!this.wrapperEl)
            return;

        this.parent();

        // Create the container element and generate the URL
        var listEl = new Element("ul").injectInside(this.containerEl),
            url = Librarian.path.getMethodUrl("getvps") + "&out=ujson&all=1&orderBy=" + this.options.orderBy + "&order=" + this.options.order + "&perpage=" + this.options.count;

        // Use the view to get the cat id for hash linking, if it's provided
        if (Librarian.search.viewNameByType[Librarian.Search.outputTypes.MYFAVORITE])
            url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.MYFAVORITE];

        this.request = new Librarian.Request.JSON({
            url: url,
            onSuccess: function (json) {
                if (!json)
                    return;

                listEl.empty();

                // Get the list of presentations, but make sure there are some before we continue
                var presentations = json.Presentations;
                if (!presentations || (presentations.length == 0))
                    return;

                // Create a line for each of the presentations
                for (var i = 0; i < presentations.length; i++) {
                    var presentation = presentations[i],
                        date = Librarian.Utils.extractDateFromString(presentation.CreatedDate).format(this.options.dateFormat),
                        url = '#';

                    presentation = Librarian.Utils.getStandardContent(presentation);

                    // Set up the hash if this is set to open
                    if (this.options.action === "open") {
                        if (presentation.PresId > 0)
                            url = "#presid=" + presentation.PresId;
                        else
                            continue;

                        if (presentation.ExtraFields && (typeof presentation.ExtraFields.CatID === "number"))
                            url += "&catid=" + presentation.ExtraFields.CatID;
                        if (presentation.PresType > Librarian.virtPresType.undefined)
                            url += "&prestype=" + presentation.PresType;

                        url += "&type=" + Librarian.catType.myFavorite;
                    }

                    // Create the list item and link for this favorite
                    var listItemEl = new Element("li", {
                        "class": (this.options.classPrefix || '') + "item"
                    }).injectInside(listEl);

                    var iconEl = new Element("img", {
                        "class": (this.options.classPrefix || '') + "icon",
                        src: Librarian.Utils.getContentTypeIcon(presentation),
                        events: {
                            click: function(event) {
                                self.clickHandler(event, presentation);
                            }
                        }
                    }).injectInside(listItemEl);

                    var linkEl = new Element("a", {
                        "class": (this.options.classPrefix || '') + "link",
                        "text": this.options.showDate ? (date + " - " + presentation.name) : presentation.name,
                        "title": presentation.name,
                        "href": url,
                        "target": "_download"
                    }).injectInside(listItemEl);

                    // If this is set to preview, save the data and add the onClick
                    if (this.options.action === "preview") {
                        linkEl.data = Object.toLowerKeys(presentation);
                        linkEl.addOnClick(function () {
                            Librarian.PreviewWindow.openPreviewWindow(this.data);
                        });
                    }
                }
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    }
});